import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Inputbox from "../../component/Inputbox";
import AuthBtn from "../../component/AuthBtn";
import { useDispatch } from "react-redux";
import * as actionCreators from "../../store/actionCreators";
import { Bars } from "react-loader-spinner";
import { Formik } from "formik";
import { loginValidation } from "../../utils/inputValidation";
import { authFood, logo } from "../../assets/images/images";
import GoogleLogin from "react-google-login";

function Login() {
  // const state = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const responseGoogle = (res) => {
    console.log(res);
  };

  return (
    <div className="w-full min-h-screen bg-[#f8f8f8] flex items-center justify-center">
      <div className="mx-auto  rounded-lg overflow-hidden  bg-white drop-shadow-md flex gap-8">
        {/* LOGO */}
        <div className="flex-1">
          <img
            src="./images/loginImg.jpg"
            alt="logo"
            className="h-full block object-cover"
          />
        </div>
        {/* FORM */}
        <div className="flex-1 h-full">
          <div className="w-[80%] mx-auto py-16">
            <div className="flex items-center mb-5">
              <h2 className="text-black text-[27px] font-Prata">
                Welcome to start resturant
              </h2>
            </div>

            <Formik
              initialValues={{ email: "", password: "" }}
              validate={loginValidation}
              onSubmit={(values) => {
                dispatch(actionCreators.login(values, setLoading, navigate));
              }}
            >
              {(props) => (
                <form
                  action=""
                  onSubmit={props.handleSubmit}
                  className=" font-Roboto pr-8"
                >
                  {/* EMail input */}
                  <div className="">
                    <Inputbox
                      type="email"
                      name="email"
                      errorMsg={props.errors.email}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.email}
                      placeholder="Enter Your Email"
                      className="rounded-[3px] w-full text-[14px] h-[45px] placeholder:text-[14px] border-[#DADADA] "
                    />
                  </div>

                  {/* Password input */}
                  <div className="mt-4 mx-auto ">
                    <Inputbox
                      type="password"
                      name="password"
                      errorMsg={props.errors.password}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      value={props.values.password}
                      placeholder="Enter Your Password"
                      className="rounded-[3px] w-full text-[14px] placeholder:text-[14px] h-[45px] border-[#DADADA] drop-shadow-2xl"
                    />
                  </div>
                  {/* Login button */}
                  <div className="mt-4 pb-5 flex items-end justify-between ">
                    <AuthBtn
                      className="w-[5rem] py-1 text-[23px] font-Ropa rounded-[3px] bg-greyPrimary text-center disabled:opacity-50 disabled:cursor-wait b  hover:opacity-80 hover:scale-[1.05] active:scale-[0.9] transition ease-out   text-white"
                      title={loading ? <Loader /> : "Login"}
                      disabled={loading}
                    />
                    <Link
                      className="hover:text-blue-40 hover:underline text-[16px] font-Roboto font-[300]  text-[#707070]"
                      to="/login"
                    >
                      Forget password?
                    </Link>
                  </div>

                  {/* signup and forget password section */}
                  <div className="w-[18.75rem]  text-lg mt-7  mx-auto 0 flex justify-center  ">
                    <div className="font-Roboto text-[15px]">
                      Dont have a account?
                      <Link
                        className="hover:text-blue-40 ml-1 font-Sacramento text-[31px]"
                        to="/signup"
                      >
                        Sign up
                      </Link>
                    </div>
                  </div>
                </form>
              )}
            </Formik>

            <div className="flex justify-center">
              <GoogleLogin
                clientId="152770046213-i2v48dk2p7m0bjpf8i0g7j4h67ncpq2m.apps.googleusercontent.com"
                buttonText="Login with google"
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                cookiePolicy={"single_host_origin"}
                isSignedIn={true}
                className="w-[15rem] mx-auto font-semibold mt-[1rem]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Loader() {
  return (
    <div className="flex justify-center items-center">
      <Bars height={25} color="#fff" margin="0 auto" />
    </div>
  );
}

export default Login;
